import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, Calendar, Clock, ChevronLeft, Download, ArrowUpRight, CheckCircle, Info, ExternalLink, MessageSquare, AlertCircle } from 'lucide-react';
export function SubscriptionInfo() {
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(false);
  // Calculate remaining days
  const today = new Date();
  const endDate = new Date('2025-09-01');
  const remainingDays = Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  // Subscription data (in a real app, this would come from an API)
  const subscription = {
    plan: 'LGS',
    status: 'Aktif',
    startDate: '01.09.2023',
    endDate: '01.09.2025',
    price: '4.999 TL',
    billingCycle: 'Yıllık',
    features: ['Tüm konu anlatım videoları', 'Sınırsız soru çözümü', 'Haftalık performans raporları', 'Deneme Sınavı Analizleri', 'Kişiselleştirilmiş çalışma programı', 'Deneme Sınavları', 'Rehberlik hizmetleri', 'Konu Takip Çizelgesi', 'Sınırsız Soru Arşivi']
  };
  // Billing history
  const billingHistory = [{
    id: 'INV-2023-001',
    date: '01.09.2023',
    amount: '4.999 TL',
    status: 'Ödendi'
  }, {
    id: 'INV-2022-002',
    date: '01.09.2022',
    amount: '399,99 ₺',
    status: 'Ödendi'
  }];
  // Handle upgrade button click
  const handleUpgrade = () => {
    // In a real app, this would navigate to an external sales page
    window.open('https://example.com/lgs-premium', '_blank');
  };
  // Handle support button click
  const handleSupportClick = () => {
    navigate('/messages');
    // In a real app, this would also trigger a support popup
  };
  return <div className="space-y-8" data-id="element-3227">
      <div className="flex items-center gap-4" data-id="element-3228">
        <button onClick={() => navigate('/profile')} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:opacity-90 transition-colors" data-id="element-3229">
          <ChevronLeft className="w-5 h-5" data-id="element-3230" />
          Geri
        </button>
        <h1 className="text-2xl font-bold" data-id="element-3231">Abonelik Bilgileri</h1>
      </div>

      {/* Current Subscription */}
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-3232">
        <div className="relative p-6 bg-black/90 rounded-xl" data-id="element-3233">
          <div className="flex flex-col md:flex-row md:items-center gap-6" data-id="element-3234">
            <div className="flex-shrink-0" data-id="element-3235">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center" data-id="element-3236">
                <Crown className="w-8 h-8 text-white" data-id="element-3237" />
              </div>
            </div>
            <div className="flex-1" data-id="element-3238">
              <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-3239">
                <div data-id="element-3240">
                  <h2 className="text-xl font-bold flex items-center gap-2" data-id="element-3241">
                    Mevcut Paketiniz: {subscription.plan}
                    <span className="text-xs py-0.5 px-2 bg-green-500/20 text-green-400 rounded-full" data-id="element-3242">
                      {subscription.status}
                    </span>
                  </h2>
                  <p className="text-gray-400 mt-1 text-sm" data-id="element-3243">
                    Yıllık abonelik planı
                  </p>
                </div>
                <div className="text-right" data-id="element-3244">
                  <div className="text-2xl font-bold" data-id="element-3245">{subscription.price}</div>
                  <p className="text-gray-400 text-sm" data-id="element-3246">
                    {subscription.billingCycle}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6" data-id="element-3247">
                <div className="flex items-center gap-2 text-sm" data-id="element-3248">
                  <Calendar className="w-4 h-4 text-purple-400" data-id="element-3249" />
                  <span className="text-gray-400" data-id="element-3250">Başlangıç:</span>
                  <span data-id="element-3251">{subscription.startDate}</span>
                </div>
                <div className="flex items-center gap-2 text-sm relative" data-id="element-3252">
                  <Clock className="w-4 h-4 text-indigo-400" data-id="element-3253" />
                  <span className="text-gray-400" data-id="element-3254">
                    Geçerlilik Bitiş Tarihi:
                  </span>
                  <span data-id="element-3255">{subscription.endDate}</span>
                  <button className="ml-1" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} data-id="element-3256">
                    <Info className="w-4 h-4 text-blue-400" data-id="element-3257" />
                  </button>
                  {showTooltip && <div className="absolute left-0 top-6 w-64 p-2 bg-gray-800 text-white text-xs rounded shadow-lg z-10" data-id="element-3258">
                      Aboneliğiniz bu tarihte sona erecektir. Kullanmaya devam
                      etmek için aboneliğinizi manuel olarak yenilemeniz
                      gerekmektedir.
                    </div>}
                </div>
                <div className="flex items-center gap-2 text-sm" data-id="element-3259">
                  <AlertCircle className="w-4 h-4 text-amber-400" data-id="element-3260" />
                  <span className="text-gray-400" data-id="element-3261">Kalan Süre:</span>
                  <span className="font-medium text-amber-400" data-id="element-3262">
                    {remainingDays} gün
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 flex justify-center" data-id="element-3263">
            <button onClick={handleUpgrade} className="px-6 py-3 bg-gradient-to-r from-yellow-500 to-amber-600 rounded-lg hover:opacity-90 transition-opacity text-base font-medium flex items-center gap-2" data-id="element-3264">
              Paketini Yükselt (LGS Premium'a Geç)
              <ExternalLink className="w-4 h-4" data-id="element-3265" />
            </button>
          </div>
        </div>
      </div>

      {/* Plan Features */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3266">
        <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-3267">
          <div className="relative p-6 bg-black/90 rounded-xl h-full" data-id="element-3268">
            <h3 className="text-lg font-bold mb-4" data-id="element-3269">
              {subscription.plan} Paket Özellikleri
            </h3>
            <ul className="space-y-3" data-id="element-3270">
              {subscription.features.map((feature, index) => <li key={index} className="flex items-center gap-2" data-id="element-3271">
                  <CheckCircle className="w-5 h-5 text-green-500" data-id="element-3272" />
                  <span data-id="element-3273">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-3274">
          <div className="relative p-6 bg-black/90 rounded-xl h-full" data-id="element-3275">
            <h3 className="text-lg font-bold mb-4" data-id="element-3276">Fatura Geçmişi</h3>
            {billingHistory.length > 0 ? <div className="space-y-4" data-id="element-3277">
                {billingHistory.map(invoice => <div key={invoice.id} className="flex items-center justify-between p-3 bg-white/5 rounded-lg" data-id="element-3278">
                    <div data-id="element-3279">
                      <div className="font-medium" data-id="element-3280">{invoice.date}</div>
                      <div className="text-sm text-gray-400" data-id="element-3281">{invoice.id}</div>
                    </div>
                    <div className="text-right" data-id="element-3282">
                      <div className="font-medium" data-id="element-3283">{invoice.amount}</div>
                      <div className="text-xs text-green-400" data-id="element-3284">
                        {invoice.status}
                      </div>
                    </div>
                    <button className="ml-4 p-2 bg-white/5 hover:bg-white/10 rounded-full transition-colors" data-id="element-3285">
                      <Download className="w-4 h-4" data-id="element-3286" />
                    </button>
                  </div>)}
              </div> : <div className="text-center py-8 text-gray-400" data-id="element-3287">
                Henüz fatura bulunmamaktadır.
              </div>}
          </div>
        </div>
      </div>

      {/* Upgrade Options */}
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-yellow-500 to-amber-600" data-id="element-3288">
        <div className="relative p-6 bg-black/90 rounded-xl" data-id="element-3289">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-3290">
            <div data-id="element-3291">
              <h3 className="text-xl font-bold text-yellow-400" data-id="element-3292">
                LGS Premium Paketine Yükselt
              </h3>
              <p className="text-gray-300 mt-2" data-id="element-3293">
                Tüm dijital içerikler + adrese teslim edilecek fiziki test
                kitapları ve deneme sınavları!
              </p>
              <p className="text-lg font-bold text-yellow-400 mt-2" data-id="element-3294">
                9.999 TL / Yıllık
              </p>
            </div>
            <button onClick={handleUpgrade} className="px-6 py-3 bg-gradient-to-r from-yellow-500 to-amber-600 rounded-lg hover:opacity-90 transition-opacity font-medium flex items-center gap-2" data-id="element-3295">
              Paketi Yükselt
              <ExternalLink className="w-4 h-4" data-id="element-3296" />
            </button>
          </div>
        </div>
      </div>

      {/* Help and Support */}
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-3297">
        <div className="relative p-6 bg-black/90 rounded-xl" data-id="element-3298">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-3299">
            <div data-id="element-3300">
              <h3 className="text-lg font-bold" data-id="element-3301">Yardıma mı ihtiyacınız var?</h3>
              <p className="text-gray-400 mt-2" data-id="element-3302">
                Aboneliğinizle ilgili sorularınız için destek ekibimizle
                iletişime geçebilirsiniz.
              </p>
            </div>
            <button onClick={handleSupportClick} className="px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg hover:opacity-90 transition-opacity font-medium flex items-center gap-2" data-id="element-3303">
              <MessageSquare className="w-5 h-5" data-id="element-3304" />
              Destek Ekibine Ulaşın
            </button>
          </div>
        </div>
      </div>
    </div>;
}